import { render } from "./Collaborators.vue?vue&type=template&id=20785bc8&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"

import "./Collaborators.vue?vue&type=style&index=0&id=20785bc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20785bc8"

export default script